export default __webpack_public_path__ + "static/media/AMS - downloaded2.a43dd221.svg";